<template>
  <div class="bind-page">
    <div class="bind-card">
      <div class="bind-avatar-wrap">
        <img v-if="params.avatar_url" :src="params.avatar_url" alt="飞书头像" class="fsAvatar"/>
        <img v-else src="../../assets/images/noper.png" alt="无权限" class="noPer"/>
      </div>
      <div class="bind-title">当前登录飞书账号：{{ params.nick }}</div>

      <!-- 绑定已有账号 -->
      <div v-if="is_bind" class="bind-form">
        <div class="bind-hint">请输入已有的登录账号用户名</div>
        <el-input type="text" v-model="params.account" placeholder="请输入登录账号用户名或邮箱"
                  suffix-icon="el-icon-user-solid" class="bind-input"/>
        <el-input type="password" v-model="params.password" placeholder="请输入登录密码" class="bind-input"
                  suffix-icon="el-icon-lock"
                  @keyup.enter.native="sure"/>
        <div v-if="errMessage" class="err">
          {{ errMessage }}
        </div>
        <el-button type="danger" class="bind-btn" :disabled="!params.account||!params.password"
                   @click="sure">确认绑定
        </el-button>
        <el-button type="info" class="bind-btn bind-btn-back"
                   @click="is_bind=false">上一步
        </el-button>
      </div>

      <!-- 首次登录提示 -->
      <div v-else class="bind-tip">
        <div class="bind-hint">飞书首次登录，还未绑定平台自有账户</div>
<!--        <el-button type="primary" @click="register" :disabled="true">以飞书昵称注册新账号</el-button>-->
<!--        <el-button type="danger" @click="is_bind=true" :disabled="true">绑定已有帐号</el-button>-->
        <p class="bind-tip-text">可使用其他方式登录（账号或者钉钉授权登录），再根据提示绑定飞书账号（用户（顶部菜单右上角） - 基本信息 - 飞书绑定）</p>
      </div>

      <div class="bind-back">
        <el-button type="text" icon="el-icon-back" @click="goLogin">返回登录页面</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {bindFeishu, getAuth} from '@/api/login'

export default {
  name: 'bindFeishu',
  data() {
    return {
      is_bind: false,
      params: {
        is_bind: false,
        nick: '',
        unionid: '',
        openid: '',
        fs_user_id: '',
        avatar_url: '',
        account: '',
        password: '',
      },
      errMessage: ''
    }
  },
  mounted: function () {
    this.redirect = this.$route.query.redirect || '/';
    const info = localStorage.getItem('userFeishu') ? JSON.parse(localStorage.getItem('userFeishu')) : false;
    if (!info) {
      this.$notify.warning('飞书信息丢失无法操作，请返回登录页！！！')
      this.$router.push({path: '/login'});
      return
    }
    this.params = {
      is_bind: false,
      nick: info.name || info.en_name || '',
      unionid: info.union_id || '',
      openid: info.open_id || '',
      fs_user_id: info.user_id || '',
      avatar_url: info.avatar_url || '',
      account: '',
      password: '',
    }
  },
  methods: {
    // 返回登录页面
    goLogin() {
      // 清除飞书临时登录信息，避免返回登录后再次自动跳转到绑定页
      localStorage.removeItem('userFeishu');
      this.$router.push({path: '/login'});
    },
    // 以飞书昵称注册新账号
    register() {
      if (!this.params.nick) {
        this.errMessage = '飞书昵称为空，请改用「绑定已有帐号」'
        this.is_bind = true
        return
      }
      this.params.is_bind = false
      this.submit()
    },
    sure: function () {
      this.params.is_bind = this.is_bind
      this.submit()
    },
    submit() {
      this.errMessage = ''
      bindFeishu(this.params).then(res => {
        if (res.success && res.model && !res.model.is_register) {
          // 绑定/注册成功 直接登录
          this.$store.dispatch('login', res.model);
          this.loginSuccess(res);
          this.$message.success('操作成功')
        } else {
          this.errMessage = res.message || '操作失败'
          this.$message.error(this.errMessage)
        }
      });
    },
    // 登录成功后
    loginSuccess: function (val) {
      let user = {};
      getAuth().then(res => {
        user = Object.assign({}, res.model, val.model);
        this.$store.dispatch('login', user);
        if (user.permissions.show_summary_sale || user.permissions.show_summary_data || user.permissions.show_summary_executor) {
          this.$router.push({name: 'homeOld'});
        } else if (user.permissions.manage_menu_adv_order) {
          this.$router.push({name: 'ad-order'});
        } else {
          if (user.permissions.length === 0) {
            this.$router.push({path: '/noPermisson'});
          } else {
            this.$router.push({path: '/'});
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.bind-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
    background: #f5f7fa;
}

.bind-card {
    width: 460px;
    max-width: 100%;
    padding: 48px 56px;
    box-sizing: border-box;
    text-align: center;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
}

.bind-avatar-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
}

.fsAvatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #f0f2f5;
}

.noPer {
    width: 80px;
    height: 80px;
}

.bind-title {
    margin-bottom: 32px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.bind-form {
    text-align: left;
}

.bind-hint {
    margin-bottom: 16px;
    font-size: 14px;
    color: #606266;
}

.bind-input {
    width: 100%;
    margin-bottom: 16px;
}

.bind-btn {
    display: block;
    width: 100%;
    margin-left: 0;
}

.bind-btn-back {
    margin-top: 10px;
}

.err {
    margin-bottom: 8px;
    font-size: 13px;
    color: #f56c6c;
    text-align: left;
}

.bind-tip {
    text-align: center;
}

.bind-tip .bind-hint {
    text-align: center;
}

.bind-tip .el-button + .el-button {
    margin-left: 16px;
}

.bind-tip-text {
    margin: 20px 0 0;
    font-size: 13px;
    line-height: 1.8;
    color: #909399;
    text-align: left;
}

.bind-back {
    margin-top: 28px;
    padding-top: 20px;
    border-top: 1px dashed #e4e7ed;
}

.bind-back .el-button {
    font-size: 14px;
}
</style>
